export default __webpack_public_path__ + "static/media/introduction.946b4482.mp4";